import { EditOutlined } from "@ant-design/icons";
import { Switch, Typography } from "antd";

import * as theme from "./theme.css";
const { Text } = Typography;

export interface FeatureListItemProps {
    featureKey: string;
    isEnabled: boolean;
    description?: string;
    onChange: (isEnabled: boolean) => void;
    defaultEnabled: boolean;
    disabled?: boolean;
}

export function FeatureListItem({
    featureKey,
    description,
    isEnabled,
    onChange,
    defaultEnabled,
    disabled = false,
}: FeatureListItemProps) {
    const override = <EditOutlined />;
    return (
        <div className={theme.listItem}>
            <div className={theme.switchStyle}>
                <Switch
                    checked={isEnabled}
                    disabled={disabled}
                    onChange={onChange}
                    checkedChildren={!defaultEnabled ? override : null}
                    unCheckedChildren={defaultEnabled ? override : null}
                />
                {featureKey}
            </div>
            {description && <Text type="secondary">{description}</Text>}
        </div>
    );
}
